import { render } from "./batchSelect.vue?vue&type=template&id=460ca870&scoped=true"
import script from "./batchSelect.vue?vue&type=script&lang=js"
export * from "./batchSelect.vue?vue&type=script&lang=js"

import "./batchSelect.vue?vue&type=style&index=0&id=460ca870&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460ca870"]])

export default __exports__